import { useMsal } from "@azure/msal-react";
import { useCallback } from 'react'; // Import useCallback

const useAuthToken = () => {
  const { instance, accounts } = useMsal();

  // Memoize getAuthToken with useCallback
  const getAuthToken = useCallback(async (scope: string) => {
    // Ensure accounts[0] exists before trying to use it
    if (!accounts || accounts.length === 0) {
      console.error("No accounts available for token acquisition.");
      // Optionally, trigger login or show an error
      // For now, return null or throw an error
      return null;
    }

    try {
      const response = await instance.acquireTokenSilent({
        scopes: [scope],
        account: accounts[0] // Use the first account
      });
      // console.log("Token acquired successfully (silent)", response.accessToken.substring(0, 10) + "..."); // Log less verbosely
      return response.accessToken;
    } catch (error) {
      console.warn("Silent token acquisition failed, attempting popup:", error); // Use warn for non-critical failure
      try {
        // Fallback to popup
        const response = await instance.acquireTokenPopup({
          scopes: [scope],
          // Optionally specify account hint if needed, but often not required for popup
        });
        // console.log("Token acquired successfully (popup)", response.accessToken.substring(0, 10) + "..."); // Log less verbosely
        return response.accessToken;
      } catch (popupError) {
        console.error("Popup token acquisition failed:", popupError);
        // Consider more robust error handling or user notification here
        return null; // Return null if popup also fails
      }
    }
  }, [instance, accounts]); // Add instance and accounts as dependencies

  return { getAuthToken }; // Return the memoized function
};

export default useAuthToken;
